<template>
<div fillHeight="lastHeight" scroll ref="detailContent">
	<div class="mb1x vaT_E">
		<!-- 系统概要start -->
		<StationSummary ref="StationSummary" @stepTo="summaryStepTo"></StationSummary>
		<!-- 系统概要end -->
		<!-- 电站信息摘要start -->
		<!-- <StationBasicInfo ref="StationBasicInfo"></StationBasicInfo> -->
		<!-- 电站信息摘要end -->
		<div class="pl05x pr05x clearfix fL_E w50pct_E pl05x_E pr05x_E" v-if="functionType=='GENERATION'">
			<!-- 发电实时start -->
			<div>
				<GeneratePower :type="basicInfo.powerType==='PV' ? 'light' : 'wind'" ref="GeneratePower" :fromWhere="'child'"></GeneratePower>
			</div>
			<!-- 发电实时end -->
			<!-- 节能减排start -->
			<div class="vaT">
				<SaveEnergy ref="SaveEnergy"></SaveEnergy>
			</div>
			<!-- 节能减排end -->
		</div>
		<!-- 用电实时start -->
		<UsePower ref="UsePowerInfo" class="mr1x ml1x" v-if="functionType=='CONSUMPTION'" :fromChild="'childDetail'"></UsePower>
		<!-- 用电实时end -->
		<!-- 发电历史start -->
		<generateHistory  :StationType="basicInfo.powerType==='PV' ? 'light' : 'wind'"  ref="generateHistory" v-if="functionType=='GENERATION'" :baseInfo='basicInfo' :collectTime='stationInfo' :timeZoneCode="basicInfo.region?basicInfo.region.timezone:stage.time.timeZoneCode" :fromChild="'childDetail'"></generateHistory>
		<!-- 发电历史end -->
		<!-- 用电历史start -->
		<ConsumptionHistory ref="consumptionHistory" v-if="functionType=='CONSUMPTION'"></ConsumptionHistory>
		<!-- 用电历史start -->
	</div>
</div>
</template>
<script>
import { mapGetters,mapMutations,mapActions} from 'vuex'

import * as lib from "@/util/lib.js";
import {searchAreaList} from "@/api/base.js";
import {getLocal} from '@/util'
import * as equipmentApi from '@/api/maintain/plant/list'
import Loading from '@/components/common/ui/Loading'
import {getLanguageStr} from "@/util/language.js"

import generateHistory from '@/view/maintain/light/plant/detail/GenerateHistory' //发电历史
import StationSummary from '@/view/maintain/light/plant/detail/StationSummary' //信息摘要
import SaveEnergy from '@/view/maintain/light/plant/detail/SaveEnergy'   //节能
import GeneratePower from '@/view/maintain/light/plant/detail/GeneratePower' //实时发电
import UsePower from '@/view/maintain/light/plant/detail/UsePower' //用电实时
import ConsumptionHistory from '@/view/maintain/light/plant/detail/ConsumptionHistory' //
// import FlowChart from '@/view/maintain/light/plant/detail/FlowChart' //流程图
// import GridPower from '@/view/maintain/light/plant/detail/GridPower' //实时用电
// import StationBasicInfo from '@/view/maintain/light/plant/detail/StationBasicInfo' //电站基本信息摘要


export default {
	components: {Loading,generateHistory,StationSummary,GeneratePower,SaveEnergy,UsePower,ConsumptionHistory},
	props: {
    StationType: {
      type: String,
      default: 'light'
    }
  },
	data(){
		return{
			stage,
			stationInfo:{},
			basicInfo:{},
			stationId:null,
			systemId:null,
			functionType:null,
			basicCost:{},
			isLoading:false,
			isAssign:true,//实时数据状态
			metering:[],//记录图表时需要用到的数据，从vuex里获取会有顺序差，导致数据不准确
			local: {},
			// metering:{},
			assignInfo:{},//实时数据
			timeDisable:false,
			DashWidth:0,
		}
	},
	computed:{
		...mapGetters({
			ActiveIndex:'equipment/ActiveIndex',
			currentIndex:'stationDetail/currentIndex',
			// metering:'stationDetail/metering',
			// stationId: 'stationDetail/stationId',
		}),
	},
	watch:{
		assignInfo(val){
			if(val.gridInterconnectionType=='EXCESS'){
				this.$nextTick(()=>{
					this.$set(this,"DashWidth",parseInt(this.$refs.DashLines.clientWidth*0.3))
				})
			}
		},
		currentIndex(val){
			if(val==0 && this.assignInfo.gridInterconnectionType=='EXCESS'){
				this.$nextTick(()=>{
					this.$set(this,"DashWidth",parseInt(this.$refs.DashLines.clientWidth*0.3))
				})
			}
		}
	},
	created(){
		this._getLocal();
	},
	updated(){
		this.handleWinWidth()
	},
	methods:{
		getLanguageStr,
		floatFix:lib.floatFix,
		convertData:lib.convertData,
		getTypeText:lib.getTypeText,
		...mapMutations({
			CHANGE:'equipment/CHANGE',
			GET_METERING:'stationDetail/GET_METERING'
		}),
		handleWinWidth(){
			window.onresize = () => {
				return (() => {
					if(this.assignInfo.gridInterconnectionType=='EXCESS'){
						this.$set(this,"DashWidth",parseInt(this.$refs.DashLines.clientWidth*0.3))
					}
				})()
			}
		},
		show(data){
			this.stationId=data.stationId
			this.systemId=data.systemId
			this.functionType=data.functionType

			this._getAllInfo(data.systemId)

			this.$refs.StationSummary.show({  //打开系统概要
				stationId:this.stationId,
				systemId:this.systemId,
				level:1
			})
		},
		_getAllInfo(id){
			Promise.all([this.geStationInfo(id),this.getBasicInfo()]).then(res=>{
				this.stationInfo=res[0]
        this.basicInfo=res[1]
        // console.log(this.basicInfo.powerType)
				if(this.functionType=='GENERATION'){
						this.$refs.GeneratePower.show({   //打开发电实时
							stationId:this.stationId,
							systemId:this.systemId,
							level:1,
							stationInfo:res[0]
						})
						this.$refs.SaveEnergy.show({   //打开节能减排
							stationId:this.stationId,
							systemId:this.systemId,
							level:1,
							stationInfo:res[0]
						})
						// console.log(res)
						res[1].lastUpdateTime = res[1].lastModifiedDate*1000
					
						this.$refs.generateHistory.show({   //打开历史图表
							stationId:this.stationId,
							systemId:this.systemId,
							level:1,
							basicInfo:res[1],
						})
				}else{
					this.$nextTick(()=>{
						if(this.$refs.UsePowerInfo){
							this.$refs.UsePowerInfo.show({stationId:this.stationId,systemId:this.systemId,stationInfo:res[0]});//打开用电实时
						}
						if(this.$refs.consumptionHistory){
							this.$refs.consumptionHistory.show({//打开自发自用历史图表
								stationId:this.stationId,
								systemId:this.systemId,
								assignInfo:res[0],
								metering:res[0],
								basicInfo:res[1],
							});
						}
					})
				}
				setTimeout(lib.fillHeight,500);
			},error=>{
				this.isLoading=false
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		// 获取详情-电站信息
		geStationInfo(id){
			return new Promise((resolve,reject)=>{
				equipmentApi.StationInfo(id).then(response=>{
					resolve(response)
				},error=>{
					reject(reject)
				})
			})
		},
		getBasicInfo(){
			return new Promise((resolve,reject)=>{
				equipmentApi.StationBasicInfo(this.stationId).then(response=>{
					resolve(response)
				},error=>{
					reject(reject)
				})
			})
		},
		//获取电站成本
		_getBasicCost(id){
			equipmentApi.StationCost(id).then(response=>{
				this.basicCost=response
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		_getLocal() {
			this.local = getLocal()
		},
		//获取实时发电
		// _getGeneratePower(id){
		// 	this.$refs.GeneratePower.isLoading=true
		// 	this.$refs.SaveEnergy.isLoading=true
		// 	equipmentApi.GeneratePower(id).then(res=>{
		// 		this.$refs.GeneratePower.isLoading=false
		// 		this.$refs.SaveEnergy.isLoading=false
		// 		this.$refs.GeneratePower.show({   //发电实时
		// 			id:id,
		// 			assignInfo:res
		// 		})
		// 		this.$refs.SaveEnergy.show({   //节能减排
		// 			id:id,
		// 			assignInfo:res
		// 		})
        //     },error=>{
        //          !_.isEmpty(error) && this.$notify(error)
        //     })
		// },
			//系统概要跳转
		summaryStepTo(data){
			this.$emit('stepToDevice',data)
		},
		reset(){
			this.metering=[]
		},
	},
	mounted(){
		lib.fillHeight();
		lib.setScroll($(this.$el));
	}
}
</script>
<style lang="scss" scoped>
.datepicker{width:125px !important;height:2.2em;line-height:2.2em}
.datepicker-range{min-width: auto;}
.textCut_E >.s-title{color:#000;max-width: 14em; display: inline-block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;padding-left:2px}
.titleBar{
	height: auto;;
}
.vt{vertical-align: top}
// .fs18x{font-size:1.6em}
.clearfix::after{
	content: "";
	display: block;
	clear: both;
}
.realTimeInfo{
	min-height: 379px
}
.realTimeInfo ul.w33pct_E>*{
	width: 30%
}
.chartLoading{
	min-height:3em;
	:deep(.mt2x){
		margin-top:0
	}
}
#baseInfo{
	min-height: 263px
}
@media screen and (max-width: 1660px){
	.realTimeInfo ul > *{
		width: 20%
	}
}
// .txt{
// 	color: #000;
// 	text-align:center;
// 	border-top:1px solid rgba(0, 0, 0, 0.1);
// 	border-bottom:1px solid rgba(0, 0, 0, 0.1);
// 	>.txtN>div>div{
// 		display: inline-block;
// 		margin: 0 15px;
// 		line-height: 3em;
// 	}
// }
.textL{
	text-align: left;
}
.textR{
	text-align: right;
}
.transWidth{
	transition:width .5s ease-in
}
.fade-enter-active, .fade-leave-active {
  transition: width 5s ease-in
}
.fade-enter, .fade-leave-to{
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/ChildDetail.vue